import type { AppIconProps } from '../Icons.types';
import { getClassNames } from '../Icons.utils';
import styles from './ShareIcon.module.scss';

export const AppShareIcon = (props: AppIconProps) => {
  const { className, ...rest } = props;

  const classNames = getClassNames(styles.icon, className);

  return (
    <svg
      {...rest}
      className={classNames}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66797 5.25H4.08464C3.77522 5.25 3.47847 5.37292 3.25968 5.59171C3.04089 5.8105 2.91797 6.10725 2.91797 6.41667V11.0833C2.91797 11.3928 3.04089 11.6895 3.25968 11.9083C3.47847 12.1271 3.77522 12.25 4.08464 12.25H9.91797C10.2274 12.25 10.5241 12.1271 10.7429 11.9083C10.9617 11.6895 11.0846 11.3928 11.0846 11.0833V6.41667C11.0846 6.10725 10.9617 5.8105 10.7429 5.59171C10.5241 5.37292 10.2274 5.25 9.91797 5.25H9.33464M7.0013 8.16667V1.75M7.0013 1.75L5.2513 3.5M7.0013 1.75L8.7513 3.5"
        stroke="var(--color-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
